export default __webpack_public_path__ + "static/media/2020학년도_하반기_학교설명회.47bade54.pdf";